import { render, staticRenderFns } from "./BadgeView.vue?vue&type=template&id=689f595c&scoped=true&"
import script from "./BadgeView.vue?vue&type=script&lang=js&"
export * from "./BadgeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f595c",
  null
  
)

export default component.exports